import {
  Errors,
  ErrorTypes,
  FlattenedErrorsObjectArray,
  flattenErrorTypeArray,
  FlexColumn,
  groupErrorsByNonProperty,
  InfoList,
  WarningInfo,
  WarningInfoDanger,
} from '@equifinance/shared';
import { ComponentType } from 'react';
import styled from 'styled-components';

export const ExpandableErrorsContainer = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[2]};
  padding:${theme.padding[4]};
`}`;

export function ExpandableRowErrors({
  errors = [],
  warnings = [],
}: {
  errors?: FlattenedErrorsObjectArray,
  warnings?: FlattenedErrorsObjectArray,
}) {
  const filteredErrors = groupErrorsByNonProperty(errors);
  const rejectDataErrors = filteredErrors?.[ErrorTypes.RejectData] ?? [];
  const validationFailureErrors = filteredErrors?.[ErrorTypes.ValidationFailure] ?? [];

  const filteredWarnings = groupErrorsByNonProperty(warnings);
  const referWarnings = filteredWarnings?.[ErrorTypes.Refer] ?? [];
  const warningWarnings = filteredWarnings?.[ErrorTypes.Warning] ?? [];

  return (
    <ExpandableErrorsContainer>
      {rejectDataErrors.length > 0 && (
        <WarningInfoDanger>
          <InfoList items={rejectDataErrors?.map((fe) => (
            fe.errorMessage
          ))}
          />
        </WarningInfoDanger>
      )}

      {validationFailureErrors.length > 0 && (
        <WarningInfoDanger>
          <InfoList items={validationFailureErrors?.map((fe) => (
            fe.errorMessage
          ))}
          />
        </WarningInfoDanger>
      )}

      {referWarnings.length > 0 && (
        <WarningInfo>
          <InfoList
            items={referWarnings?.map((fe) => (
              fe.errorMessage
            ))}
          />
        </WarningInfo>
      )}

      {warningWarnings.length > 0 && (
        <WarningInfo>
          <InfoList
            items={warningWarnings?.map((fe) => (
              fe.errorMessage
            ))}
          />
        </WarningInfo>
      )}
    </ExpandableErrorsContainer>
  );
}

export function withExpandableRowErrors(Component: ComponentType<any>) {
  return function ({
    data, errors = {}, warnings = {}, ...props
  }: { data: any, errors?: Errors, warnings?: Errors }) {
    return (
      <FlexColumn>
        <ExpandableRowErrors errors={flattenErrorTypeArray(errors[data?.id]) ?? []} warnings={flattenErrorTypeArray(warnings[data?.id]) ?? []} />
        <Component data={data} errors={errors} warnings={warnings} {...props} />
      </FlexColumn>
    );
  };
}
